import type { Notification } from '../../../../lib/flotiq-client/types/external-api-response';

import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { getTestProps, getTranslatedField } from '../../../../lib/helpers';

import {
  ArrowRightThinIcon,
  WarningFilledIcon,
} from '../../../../images/shapes';

const formatDate = (value: string | Date) => {
  const m = moment(value);
  const daysDiff = moment().diff(m, 'hours');
  if (daysDiff < 24) {
    return m.fromNow();
  }
  return m.format('L');
};

const NotificationsItem = ({
  notification,
  lastNotificationDateBeforeOpen,
  testId,
}: {
  notification: Notification;
  lastNotificationDateBeforeOpen?: string;
  testId?: string;
}) => {
  const { t, i18n } = useTranslation();
  const link = getTranslatedField(notification, 'article_link', i18n.language);

  const isNew = lastNotificationDateBeforeOpen
    ? moment(notification.internal.createdAt).isAfter(
        moment(lastNotificationDateBeforeOpen),
      )
    : true;

  return (
    <li className="flex gap-2 py-4">
      <WarningFilledIcon className="w-4 h-4 shrink-0 mt-0.5 text-blue" />
      <div className="w-full">
        <div className="flex items-center font-bold mb-1 gap-2">
          <p>
            {getTranslatedField(notification, 'title', i18n.language)}
            {isNew && (
              <span
                className="text-blue"
                {...getTestProps(testId, 'new-indicator')}
              >
                {' *'}
              </span>
            )}
          </p>
          <p className="font-normal ml-auto text-xs text-slate-500 dark:text-slate-300">
            {formatDate(notification.internal?.createdAt)}
          </p>
        </div>
        <div
          className={
            'notifications-content text-sm ul:list-disc ol:list-decimal ul:ml-4 ol:ml-4 dark:text-slate-300'
          }
          dangerouslySetInnerHTML={{
            __html:
              getTranslatedField(notification, 'content', i18n.language) || '',
          }}
        />
        {link && (
          <a
            href={link}
            target="_blank"
            rel="noreferrer"
            className="block text-blue-500 dark:text-slate-200 hover:underline mt-2 text-sm py-2 lg:py-0"
          >
            {t('Global.ReadMore')}
            <ArrowRightThinIcon className="inline ml-1 w-2.5 min-w-2.5 text-blue" />
          </a>
        )}
      </div>
    </li>
  );
};

export default NotificationsItem;
